import React, { useState } from 'react';
import { Button, Input } from 'reactstrap';
import { FormFieldHeader } from '../../../../../components/FormFieldHeader';

interface ModalProps {
  name: string;
  token: string;
  onSubmit: (name: string) => Promise<void>;
  onClose: (succeeded?: boolean) => void;
}

export function ModalBody({ name, token, onSubmit, onClose }: ModalProps) {
  const [apiKeyName, setApiKeyName] = useState<string>(name ?? '');
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const isFormValid = apiKeyName.trim().length > 0;

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();

    if (!isFormValid || isSaving) return;

    setIsSaving(true);
    try {
      await onSubmit(apiKeyName.trim());
      onClose(true);
    } catch (error) {
      onClose(false);
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormFieldHeader
        fieldName='Key Name'
        isRequired={true}
        hideRequireIndicator={true}
        classNames='mb-2 fs-5'
      />
      <Input
        type='text'
        value={apiKeyName}
        onChange={(e) => setApiKeyName(e.target.value)}
        placeholder='Enter Key Name'
        disabled={isSaving}
        aria-label='Enter Key Name'
        className='form-control mb-3 mt-0'
      />

      <FormFieldHeader
        fieldName='API Key'
        hideRequireIndicator={true}
        classNames='mb-2 fs-5'
      />
      <Input
        type='text'
        value={token}
        disabled={true}
        aria-label='API Key Token'
      />
      <div className='d-flex mt-4 justify-content-end'>
        <Button
          type='button'
          color='danger'
          className='me-2'
          onClick={() => onClose()}
          disabled={isSaving}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          disabled={!isFormValid || isSaving || apiKeyName === name}
          color='primary'
        >
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </form>
  );
}
